import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import SneakerCard from "./SneakerCard";
import SneakerImage from "./SneakerImage";
import SneakerSummary from "./SneakerSummary";
import SneakerSize from "./SneakerSize";
import SneakerTitle from "./SneakerTitle";

import SneakerHeader from "./SneakerHeader";
import { getCacheImage } from "../../config";
import SneakerFooter from "./SneakerFooter";
import { normalizeBrand, getCloudImageUrl, categoryURL, categoryString } from "../../utils";
import emptySneakerImg from "../../images/emptysneakers2.png";
import emptyApparelImg from "../../images/emptyapparels.png";
import emptyHandbagImg from "../../images/emptyhandbags.png";
import { convertBrandNameToSlug, emptyImage } from "utils/Helpers";

const urlProduct = props => {
  if (props.category === "sneakers")
    return `/sneakers/${props.id}/${props.slug}`;
  else if (props.category === "apparels")
    return `/apparels/${props.id}/${props.slug}`;
};

export default function Sneaker(props) {
  const category = typeof props.category === "string" ? props.category : props.category.selected;
  const categoryUrl = categoryURL(category);
  // const url = props.isPreVerified ? (props.collectionSlug ? `/${categoryUrl}/${props.id}/${props.slug}?collection=${props.collectionSlug}&pre_verified=true` : `/${categoryUrl}/${props.id}/${props.slug}?pre_verified=true` ) : ( props.vintage ? `${categoryUrl}/${props.id}/${props.slug}?vintage=true` : `/${categoryUrl}/${props.id}/${props.slug}`);
  const brandSlug = props?.brandSlug || convertBrandNameToSlug(props?.brands?.[0] || props?.product?.brand?.flat?.[0]);
  let url = `/${categoryUrl}/${brandSlug}/${props.slug}`;
  let query = ''
  if (props.isPreVerified && !props.collectionSlug && !props.vintage) query += `?express_shipping=true`;
  if (!props.isPreVerified && props.collectionSlug && !props.vintage) query += `?collection=${props.collectionSlug}`;
  if (!props.isPreVerified && !props.collectionSlug && props.vintage) query += `?vintage=true`;

  if (props.isPreVerified && props.collectionSlug && !props.vintage) query += `?collection=${props.collectionSlug}&express_shipping=true`;
  if (!props.isPreVerified && props.collectionSlug && props.vintage) query += `?collection=${props.collectionSlug}&vintage=true`;
  if (props.isPreVerified && !props.collectionSlug && props.vintage) query += `?express_shipping=true&vintage=true`;

  if (props.isPreVerified && props.collectionSlug && props.vintage) query += `?collection=${props.collectionSlug}&express_shipping=true&vintage=true`;
  const hotProducts = props.hotProducts || props.editors_choice;
  const isOnlyKickPoint = props?.variant_payment_methods?.length === 1 && !!props?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point" || item === "kick_point");
  const isHotProducts = window.location.pathname.includes('hot-products');
  const isSearch = !isHotProducts;

  if (!props.isCollectionPage) {
    if (isSearch) {
      query += `${query.includes('?') ? '&' : '?'}from=search`;
    }

    if (isHotProducts) {
      query += `${query.includes('?') ? '&' : '?'}from=hot-products`;
    }
  }

  return (
    <SneakerCard
      url={url}
      activeId={props.activeId}
      updateActiveId={props.updateActiveId}
      id={props.id}
      similarProducts={props.similarProducts}
      productPrice={props.latest_price && props.latest_price.asking_price}
      query={query}
      isCollectionPage={props.isCollectionPage}
      collection_id={props.collection_id}
    >
      <SneakerImage
        imageTitle={props.display_name}
        hasImage={props.product_variant_images.length ? true : false}
        src={
          props.product_variant_images.length
            ? getCloudImageUrl(props.product_variant_images[0].URL, 400)
            : emptyImage(categoryString(props.category))
        }
        alt={props.display_name}
        category={categoryString(props.category)}
        hotProducts={hotProducts}
      />
      <SneakerFooter
        brand_title={props.product.brand ? (categoryString(props.category) === "lifestyles" ? normalizeBrand(props.product.brand.title ? props.product.brand.title : props.product.brand.name) : normalizeBrand(props.product.brand.flat[0])) : null}
        subCategory={props.product.brand ? props.product.brand.flat : null}
        category={props.product.category ? props.product.category.name : props.category}
        title={props.display_name}
        latestPrice={props.latest_price}
        statusPage={props.statusPage}
        isOnlyKickPoint={isOnlyKickPoint}
      />
    </SneakerCard>
  );
}

const styles = {
  sizeUndefined: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center"
  }
};
